import { createContext, useContext } from 'react'
import type { TableCellPadding, TableCellSize } from '../TableCell/TableCell'

export type TableCellVariant = 'head' | 'body' | 'footer'

export interface TableContextValue {
  padding?: TableCellPadding
  size?: TableCellSize
  stickyHeader?: boolean
  variant?: TableCellVariant
}

export const TableContext = createContext<TableContextValue | undefined>(undefined)

export const useTableContext = () => useContext(TableContext)
